module.exports = __webpack_public_path__ + "img/un-favorites.5ca988ea.svg";